export function formatNumber(value) {
  let fullLocale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  // Normalize locale strings to the BCP 47 standard (default in JS)
  const normalizedLocale = fullLocale.replace(/_/g, '-');

  // Handle Arabic locales specifically to ensure numbering system is set to 'latn'
  if (normalizedLocale.startsWith('ar')) {
    options.numberingSystem = 'latn';
  }
  return Number(value).toLocaleString(normalizedLocale, options);
}
export function roundNumber(number) {
  let precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  const power = Math.pow(10, precision);
  return Math.round(number * power) / power;
}
export function formatRoundNumber(value) {
  let precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  let fullLocale = arguments.length > 2 ? arguments[2] : undefined;
  let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return formatNumber(roundNumber(Number(value), precision).toFixed(precision), fullLocale, options);
}
//# sourceMappingURL=format-number.js.map